// extracted by mini-css-extract-plugin
export default {"row":"DesktopMenu_row__DpRZR","column":"DesktopMenu_column__Ttfc-","pullRight":"DesktopMenu_pullRight__RC3se","small":"DesktopMenu_small__RPYtQ"};